import React from 'react';
import { Link } from 'react-router-dom';
import { CircleCheck, ArrowRight, BadgePercent } from 'lucide-react';
import { IMAGES } from '../../data/site';
import { Reveal } from '../common/Reveal';

const bullets = [
  'Save Up to 40% on roofing services.',
  'Experienced and trusted professionals.',
  'High-quality materials and workmanship.',
  'Free in-house estimates.',
];

export const ExpertServices = ({ title = 'Expert Roofing Services in New Jersey', intro }) => (
  <section className="py-24 bg-background" data-testid="expert-services-section">
    <div className="max-w-[1320px] mx-auto px-4 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <span className="eyebrow">Serving All of North Jersey</span>
        <h2 className="section-title mt-4" data-testid="expert-services-title">{title}</h2>
        <p className="mt-5 text-lg text-muted-foreground">
          {intro || 'Phoenix Roofing & Chimney proudly serves Bergen, Passaic, Hudson, Essex, Morris, Hunterdon, Somerset, Sussex, Union, and Warren Counties.'}
        </p>
        <ul className="mt-7 space-y-3.5">
          {bullets.map((b) => (
            <li key={b} className="flex items-start gap-3 font-heading font-semibold">
              <CircleCheck className="w-5 h-5 text-primary mt-1 shrink-0" />
              {b}
            </li>
          ))}
        </ul>
        <Link to="/free-estimate" className="btn-cta mt-9" data-testid="expert-services-cta">
          Get in Touch <ArrowRight className="w-4 h-4" />
        </Link>
      </Reveal>

      <Reveal delay={0.12} className="relative">
        <img src={IMAGES.roofingTypes} alt="Roofing types" className="w-full h-[380px] md:h-[480px] object-cover rounded-3xl" loading="lazy" />
        <div className="absolute -bottom-6 left-6 md:left-8 bg-card rounded-2xl shadow-card border border-border px-6 py-5 flex items-center gap-4">
          <span className="w-12 h-12 rounded-xl inline-flex items-center justify-center text-primary-foreground" style={{ background: 'var(--gradient-fire)' }}>
            <BadgePercent className="w-6 h-6" />
          </span>
          <div>
            <p className="font-heading font-extrabold text-xl leading-none">Save up to 40%</p>
            <p className="text-muted-foreground text-sm mt-1">on installs & repairs</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
